import { bl_fi_mst_comp_einvoice_intermediary_system_RowCLass } from '../../dbschema/bl_fi_mst_comp_einvoice_intermediary_system.model';
import { BaseContainerModel } from '../base-container.model';

export class CompEinvoiceIntermediarySystemContainerModel extends BaseContainerModel {
    bl_fi_mst_comp_einvoice_intermediary_system: bl_fi_mst_comp_einvoice_intermediary_system_RowCLass = new bl_fi_mst_comp_einvoice_intermediary_system_RowCLass();
}
